import React from 'react';
import imageSrc from 'assets/img/loader.gif';
import i18n from 'i18n';

const LOADER_SIZE = 20;

export interface ISimpleLoaderProps {
  className?: string;
  loadingText?: string;
  showLoadingText?: boolean;
}

const DropzoneSpinner: React.FunctionComponent<ISimpleLoaderProps> = ({
  loadingText,
  showLoadingText,
}: ISimpleLoaderProps): JSX.Element => {
  return (
    <div className="dropzone-overlay-message">
      <img
        className={'dropzone-overlay-spinner'}
        src={imageSrc}
        alt="please wait while loading"
        height={LOADER_SIZE}
        width={LOADER_SIZE}
      />
      {showLoadingText && <span className="dropzone-overlay-text">{loadingText}</span>}
    </div>
  );
};

DropzoneSpinner.defaultProps = {
  loadingText: i18n.t('common:spinner.uploading'),
  showLoadingText: true,
};

export default DropzoneSpinner;
